import { render } from "./AppLoginRegister.vue?vue&type=template&id=46310c48&scoped=true&ts=true"
import script from "./AppLoginRegister.vue?vue&type=script&lang=ts"
export * from "./AppLoginRegister.vue?vue&type=script&lang=ts"

import "./AppLoginRegister.vue?vue&type=style&index=0&id=46310c48&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46310c48"]])

export default __exports__